import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMobileMenuOpen: false,
  currentPath: "/",
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen;
    },
    closeMobileMenu: (state) => {
      state.isMobileMenuOpen = false;
    },
    setCurrentPath: (state, action) => {
      state.currentPath = action.payload;
    },
  },
});

export const { toggleMobileMenu, setCurrentPath, closeMobileMenu } =
  navigationSlice.actions;
export default navigationSlice.reducer;
